module.exports = __webpack_public_path__ + "img/toggle-on-circle.d56724ea.svg";